import { BadgeProps } from "@/components/ui/badge";
import { FeedbackPriority, FeedbackStatus } from "@/models/feedback";

type BadgeVariant = BadgeProps["variant"];

export const STATUS_LABELS: Record<FeedbackStatus, string> = {
  new: "New",
  in_progress: "In Progress",
  resolved: "Resolved",
  closed: "Closed"
};

export const STATUS_BADGE_VARIANT: Record<FeedbackStatus, BadgeVariant> = {
  new: "secondary",
  in_progress: "info",
  resolved: "success",
  closed: "outline"
};

export const STATUS_ORDER: FeedbackStatus[] = ["new", "in_progress", "resolved", "closed"];

export const PRIORITY_LABELS: Record<FeedbackPriority, string> = {
  low: "Low",
  medium: "Medium",
  high: "High",
  urgent: "Urgent"
};

export const PRIORITY_BADGE_VARIANT: Record<FeedbackPriority, BadgeVariant> = {
  low: "outline",
  medium: "info",
  high: "warning",
  urgent: "destructive"
};

export const PRIORITY_ORDER: FeedbackPriority[] = ["low", "medium", "high", "urgent"];
